import './variables';
/**
 * 数据源信息
 */
export class ISourceInfo {
  constructor({
    connToken = null,
    instanceName = null,
    instanceType = null,
    RegionId = null,
    InstanceId = null,
    ServicePort = null,
    ServiceEdition = null,
  } = {}) {
    this.connToken = connToken;
    this.instanceName = instanceName;
    this.instanceType = instanceType;
    this.RegionId = RegionId;
    this.InstanceId = InstanceId;
    this.ServicePort = ServicePort;
    this.mark = instanceType;
    this.ServiceEdition = ServiceEdition;
  }
}
